import { Component, OnInit } from '@angular/core';
import { ModalService } from '@purespectrum1/ui';
import { ModalRef } from '@purespectrum1/ui/modal';

import { AuthService } from '../../../auth/auth.service';
import { Subscription } from 'rxjs';
import { MultiBuyerCmpAuth } from './../../../auth/auth.interface';
import { MultiBuyerModalComponent } from './../../../create-surveys/multi-buyer-modal/multi-buyer-modal.component';
import { SurveyMetaDataService } from '../../../shared/services/survey-meta-data/survey-meta-data.service';
import { DashboardStateService } from '../../../dashboard/services/dashboard-state.service';

@Component({
  selector: 'ps-multi-buyer-header',
  templateUrl: './multi-buyer-header.component.html',
  styleUrls: ['./multi-buyer-header.component.css'],
})
export class MultiBuyerHeaderComponent implements OnInit {
  private _subscriptions: Subscription = new Subscription();
  public multiBuyer?: MultiBuyerCmpAuth;
  public cmpId?: number;
  public changesNotAllowed: boolean = false;
  private _modalRef: ModalRef<MultiBuyerModalComponent> | null = null;

  constructor(
    private _authService: AuthService,
    private _modal: ModalService,
    readonly _surveyMetaDataService: SurveyMetaDataService,
    readonly _dashboardStateService: DashboardStateService
  ) {}

  ngOnInit(): void {
    this._subscriptions.add(
      this._authService.selectedMultiBuyerCompany$.subscribe(() => {
        this.multiBuyer = this._authService.selectedMultiBuyerCompany;
      })
    );

    this._subscriptions.add(
      this._dashboardStateService.completed$.subscribe((state) => {
        this.changesNotAllowed = false;
      })
    );

    this._subscriptions.add(
      this._surveyMetaDataService
        .getSurveyHeaderData()
        .subscribe((surveyHeaderData) => {
          if (surveyHeaderData.hasOwnProperty('buyerCompany')) {
            this.changesNotAllowed = true;
          } else {
            this.changesNotAllowed = false;
          }
        })
    );
  }

  selectMultiBuyer() {
    if (this._modalRef) {
      return;
    }

    this._modalRef = this._modal.open(MultiBuyerModalComponent, {
      data: { cmpId: this.multiBuyer?.parentCompany },
    });

    if (this._modalRef) {
      this._subscriptions.add(
        this._modalRef.onClose$.subscribe(() => {
          this._modalRef = null;
        })
      );
    }
  }
}
